import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { setLicenseKey } from 'survey-core';
import { VisualizerBase } from 'survey-analytics';
// Registra los locales "uk", "hu" y "sk" en survey-core: habilita Ukrainian,
// Hungarian y Slovak en el Add language del Creator y las traducciones nativas
// (botones, validaciones) del motor de respuesta cuando `Model.locale` los usa.
import 'survey-core/i18n/ukrainian';
import 'survey-core/i18n/hungarian';
import 'survey-core/i18n/slovak';

// Configurar licencia de SurveyJS
setLicenseKey(
  'ODk5ZWNlMzctNTQ3Yy00YzIyLTlmNzctMTVhY2E2NDY2ZWEzOzE9MjAyNC0xMS0xMCwyPTIwMjQtMTEtMTAsND0yMDI0LTExLTEw',
);

// SurveyJS Dashboard (`survey-analytics`) requiere una licencia de tier
// distinta a la de Core. Hasta que se renueve, suprimimos el banner de
// "maintenance expired" marcando la propiedad estática que la propia
// librería expone para este propósito.
VisualizerBase.haveCommercialLicense = true;

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
